const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
require('./GlossaryAlphabetLetter.scss');


const GlossaryAlphabetLetter = ({ active, children, disabled, onClick }) => (
    <button
        className={classNames('index--item', { active, disabled })}
        disabled={disabled}
        onClick={onClick}
    >
        {children}
    </button>
);


GlossaryAlphabetLetter.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};


module.exports = GlossaryAlphabetLetter;
